import { toGenericStrainType, toGenericCategory, toGenericEffect } from './mappings';
import { GqlStrainType, GqlProductPotency, GqlBrand } from './data.types';
import { GenericStrainType, GenericEffect, GenericProductPotency, GenericBrand } from './generic-product.types';
import { GenericCategory } from '../generic-category';

import { valueOrNull } from '../helpers';

export function transformStrainType(strainType?: GqlStrainType): GenericStrainType | null {
  return toGenericStrainType.has(strainType) ? toGenericStrainType.get(strainType) : null;
}

export function transformCategory(category?: string | null): GenericCategory | null {
  return toGenericCategory.has(category) ? toGenericCategory.get(category) : null;
}

export function transformEffects(effects?: string[] | null): GenericEffect[] {
  const genericEffects: GenericEffect[] = [];

  if (!effects) {
    return genericEffects;
  }

  effects.forEach((e) => {
    if (toGenericEffect.has(e)) {
      genericEffects.push(toGenericEffect.get(e));
    }
  });

  return genericEffects;
}

export function transformPotency(potency?: GqlProductPotency): GenericProductPotency | null {
  if (!potency) {
    return null;
  }

  const { unit, range } = potency;

  if (!range || !Array.isArray(range)) {
    return { unit, range: null };
  }

  return { unit, range } as GenericProductPotency;
}

export function transformBrand(brand?: GqlBrand): GenericBrand | null {
  if (!brand) {
    return null;
  }

  const { name, imageUrl, description } = brand;

  return {
    name,
    image: valueOrNull(imageUrl),
    description: valueOrNull(description),
  };
}
